import { t } from 'i18next';
import {
  AT_LEAST_ONE_NUMBER_REGEX,
  AT_LEAST_ONE_SPECIAL_CHARACTER,
  AT_LEAST_ONE_UPPERCASE_LETTER,
} from '@/constants/password-regex.constants';

export const getPasswordRequirements = (value: string) => {
  return [
    { text: t('auth:passwordRules.minLength'), fulfilled: value.length >= 8 },
    {
      text: t('auth:passwordRules.uppercase'),
      fulfilled: AT_LEAST_ONE_UPPERCASE_LETTER.test(value),
    },
    {
      text: t('auth:passwordRules.special'),
      fulfilled: AT_LEAST_ONE_SPECIAL_CHARACTER.test(value),
    },
    { text: t('auth:passwordRules.number'), fulfilled: AT_LEAST_ONE_NUMBER_REGEX.test(value) },
  ];
};
